
/** Highest completed tracking milestone wins, regardless of which field was edited last. */
export function inventoryFinalPosition(row: any, warehouses: any[] = [], terms: any[] = []): string {
  const dateLabel = (value: any): string | null => {
    if (!value || (value instanceof Date && !Number.isFinite(value.getTime()))) return null;
    const raw = value instanceof Date ? value.toISOString() : String(value);
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
    if (!match) return null;
    return `${Number(match[2])}/${Number(match[3])}/${match[1]}`;
  };
  if (dateLabel(row.DateIn)) {
    const id = Number(row.FinalDestinationWarehouseID);
    const warehouse = warehouses.find(w => Number(w.LocationID) === id);
    let code = '';
    if (id === 43 || (warehouse?.LocationState === 'NJ' && /^650\s/.test(warehouse?.LocationStreet ?? ''))) code = 'NJX';
    else if (id === 45 || warehouse?.LocationState === 'FL') code = 'JAX';
    else if (id === 31 || warehouse?.LocationState === 'WI' || /Costa Oro/i.test(warehouse?.LocationName ?? '')) code = 'WI';
    else if (id === 37 || warehouse?.LocationState === 'NJ') code = 'NJ';
    else code = (warehouse?.LocationLabelName || warehouse?.LocationState || warehouse?.LocationShortName || '').trim();
    return code ? `INSTORE ${code}` : (String(row.FinalPosition ?? '').startsWith('INSTORE') ? row.FinalPosition : 'INSTORE');
  }
  for (const [field, label] of [['DrayageAppointmentDate', 'WTA'], ['VesselETA', 'ETA'], ['AfloatDate', 'AFLOAT'], ['ETDDateLogistics', 'ETD']]) {
    const date = dateLabel(row[field]);
    if (date) return `${label} ${date}`;
  }
  const month = Number(row.ETDMonth), year = Number(row.ETDYear);
  const term = terms.find(t => Number(t.ShipmentTermId) === Number(row.ShippingTerm))?.ShipmentTermName;
  if (month >= 1 && month < 13 && year > 0 && term) {
    const months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    const index = Math.floor(month) - 1;
    const label = months[index] + (month !== Math.floor(month) ? '/' + months[(index + 1) % 12] : '');
    return `${label}'${String(year).slice(-2).padStart(2, '0')} ${term.toUpperCase()}`;
  }
  return row.FinalPosition ?? '';
}
